import { Dialog } from 'primereact/dialog';
import React, { useState } from 'react';
import StoresDropDown from './StoresDropDown.tsx';
import { toast } from "../../components/Toast/toast.ts";
import axios from "axios";
import { ProgressSpinner } from 'primereact/progressspinner';
import { useClientQueryContext } from '../../context/ClientQueryContext.tsx';

const AssignTaskModal: React.FC = ({ visible, setVisible }: any) => {

  const { reloadClientQueries, setReloadClientQueries } = useClientQueryContext();
  const storedToken = localStorage.getItem("token");
  const [storename, setStoreName] = useState("");
  const [selectedStore, setSelectedStore] = useState([]);
  const [subject, setSubject] = useState("");
  const [details, setDetails] = useState("");
  const [loading, setLoading] = useState(false);

  const resetInputs = () => {
    setSelectedStore([]);
    setStoreName("");
    setSubject("");
    setDetails("");
  };

  const handleAssignTask = async () => {
    try {
      if (!storedToken) return;
      if (!details || !subject || !selectedStore?.length || !storename) {
        toast.error("Please fill in all required fields.");
        return;
      }
      setLoading(true);
      const response = await axios.post(`${process.env.REACT_APP_API_URL}/api/cust-portal/custom-query-request`,
        {
          custom_query_details: details,
          custom_query_subject: subject,
          store_id: selectedStore,
          store_name: storename
        },
        { headers: { Authorization: `Bearer ${storedToken}` } }
      );
      if (response?.status === 200) {
        toast.success("Your Query has been submitted successfully!");
        setVisible(false);
        resetInputs();
        setReloadClientQueries(!reloadClientQueries);
      }
      setLoading(false);
    } catch (error: any) {
      toast.error(error?.response?.data?.message || "An error occurred. Please try again.");
      setLoading(false);
    }
  };

  const inputClass = "w-full h-[42px] px-3 text-[13px] rounded-md border border-[rgb(var(--border-secondary))] bg-[rgb(var(--surface-1))] text-[rgb(var(--text-primary))] placeholder:text-[rgb(var(--text-muted))] outline-none focus:border-gold-2 focus:ring-1 focus:ring-gold-2/20 transition-all";
  const labelClass = "text-[11px] font-semibold uppercase tracking-[0.06em] text-[rgb(var(--text-muted))] mb-1.5 block";

  return (
    <Dialog
      header="Assign Tasks"
      maximizable
      visible={visible}
      style={{ width: '480px' }}
      onHide={() => { setVisible(false); resetInputs(); }}
      breakpoints={{ '960px': '75vw', '641px': '95vw' }}
      footer={
        <div className="flex justify-end gap-2 px-6 py-4 border-t border-[rgb(var(--border-primary))]">
          <button style={{background: "var(--gold-grad)"}} onClick={handleAssignTask} className="px-4 py-2 rounded-sm hover:bg-gold-3 text-white text-[13px] font-medium transition-colors">Submit</button>
          <button onClick={() => { setVisible(false); resetInputs(); }} className="px-4 py-2 rounded-sm bg-[rgb(var(--surface-2))] border border-[rgb(var(--border-secondary))] text-[rgb(var(--text-primary))] text-[13px] font-medium hover:bg-[rgb(var(--surface-3))] transition-colors">Cancel</button>
        </div>
      }
      pt={{
        header: { className: "!bg-[rgb(var(--surface-1))] !border-b !border-[rgb(var(--border-primary))] !px-6 !py-4" },
        content: { className: "!bg-[rgb(var(--surface-1))] !p-0" },
        footer: { className: "!bg-[rgb(var(--surface-1))] !p-0" },
        headerTitle: { className: "!text-[16px] !font-semibold !text-[rgb(var(--text-primary))]" },
      }}
    >
      <div className="flex flex-col gap-5 p-6">
        {loading ? (
          <div className="flex justify-center items-center h-[200px]">
            <ProgressSpinner style={{ width: '50px', height: '50px' }} strokeWidth="3" animationDuration=".5s" />
          </div>
        ) : (
          <>
            {/* Subject */}
            <div>
              <label className={labelClass}>Subject</label>
              <input className={inputClass} value={subject} onChange={(e) => setSubject(e.target.value)} placeholder="Enter subject" />
            </div>

            {/* Store */}
            <div>
              <label className={labelClass}>Store</label>
              <StoresDropDown storename={storename} setStoreName={setStoreName} setStoreValue={setSelectedStore} storevalue={selectedStore} />
            </div>

            {/* Details */}
            <div>
              <label className={labelClass}>Comment</label>
              <textarea
                className="w-full min-h-[140px] px-3 py-2.5 text-[13px] rounded-sm border border-[rgb(var(--border-secondary))] bg-[rgb(var(--surface-1))] text-[rgb(var(--text-primary))] placeholder:text-[rgb(var(--text-muted))] outline-none focus:border-gold-2 focus:ring-1 focus:ring-gold-2/20 transition-all resize-y font-[inherit]"
                value={details}
                onChange={(e) => setDetails(e.target.value)}
                placeholder="Request Live Eye Surveillance to assign tasks to your staff..."
              />
            </div>
          </>
        )}
      </div>
    </Dialog>
  );
};

export default AssignTaskModal;
